import { render, staticRenderFns } from "./medicalList.vue?vue&type=template&id=8b52df7c&"
import script from "./medicalList.vue?vue&type=script&lang=js&"
export * from "./medicalList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports